export default __webpack_public_path__ + "static/media/04_Jumpway.4a7ceea1.png";